<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('forthing.detail.title-label') }}</h3>
        </div>

        <div v-if="(! detail) && (! transactions)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class ="container center-items" v-if="(detail) && (transactions)">
            <div class="container center-items m-0 p-0">
                <div class="card card-pricing text-center p-0 m-0 mt-4 overflow-hidden">
                    <div
                        v-bind:class="{
                            'bg-primary'  : (detail.is_active_forthing),
                            'bg-secondary': (! (detail.is_active_forthing))
                        }"
                    >
                        <span
                            class="h6 font-weight-normal w-60 mx-auto px-4 rounded-bottom bg-white shadow-sm"
                            v-bind:class="{
                                'text-primary'  : (detail.is_active_forthing),
                                'text-secondary': (! (detail.is_active_forthing))
                            }"
                        >{{ $t('forthing.detail.sub-title-label') }}</span>
                        <span class="h3 text-white d-block my-4">
                            {{
                                (detail.is_active_forthing) ?
                                $t('forthing.detail.status-labels.on') :
                                $t('forthing.detail.status-labels.off')
                            }}
                        </span>
                    </div>

                    <div class="card-body p-0 m-0">
                        <span class="h5 font-weight-bold text-black text-center d-block m-0 mt-4">
                            {{ $t('forthing.detail.total-label') }}
                        </span>
                        <span class="h4 font-weight-normal text-black text-center d-block m-0 mt-0">
                            {{ detail.total_mined_amount | round }} HEC
                        </span>

                        <span class="h5 font-weight-bold text-black text-center d-block m-0 mt-4">
                            {{ $t('forthing.detail.sub-total-label') }}
                        </span>
                        <span class="h4 font-weight-normal text-black text-center d-block m-0 mt-0 mb-4">
                            {{ detail.mined_amount | round }} HEC
                        </span>
                        
                         <span class="text-black text-right d-block m-0 mt-4" style="padding-right: 10px;">
                            <div v-if="next_wallet_reflection_date">
                                <div v-if="(isPayoutDate())" >{{ $t('forthing.detail.next-wallet-reflection-date') }}{{ this.next_payout_date | moment('YYYY/MM/DD') }}</div>
                                <div v-if="(! isPayoutDate())">{{ $t('forthing.detail.next-wallet-reflection-date') }}&ensp;&ensp;-&ensp;&ensp;</div>
                            </div>
                        </span>
                    </div>

                    <div class="card-footer m-0 py-1">
                        <span class="font-weight-normal text-black text-center d-block">
                            Update: {{ detail.updated_at | moment('YYYY/MM/DD HH:mm:ss') }} (SGT)
                        </span>
                    </div>
                </div>
            </div>

            <div class="container center-items m-0 p-0 mt-5">
                <i class="fa fa-check-circle fa-lg aube_user_wallet_check_color"></i>{{ $t('forthing.history.aube_user_wallet_check_color') }}</br>
                <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>{{ $t('forthing.history.hec_saving') }}
                <table class="table table-striped forthing-table">
                    <thead>
                        <tr class="bg-primary">
                            <th scope="col" class="text-left text-white border-0">
                                {{ $t('forthing.detail.date-label') }}
                            </th>
                            <th scope="col" class="text-left text-white border-0">
                                {{ $t('forthing.detail.volume-label') }}
                            </th>
                            <th scope="col" class="text-center text-white border-0">
                                {{ $t('forthing.detail.paid-label') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" v-bind:key="transaction.id">
                            <td class="text-left">
                                {{ transaction.created_at | moment('YYYY/MM/DD') }} (SGT)
                            </td>
                            <td class="text-left">
                                {{ transaction.amount | round }}
                            </td>
                            <td class="text-center text-success">
                                <div v-if="transaction.status === 'STATUS_SUCCESS'">
                                    <div v-if="[two_years_plan_address, two_years_plan_rokes_address].includes(transaction.to_address)">
                                        <i class="fa fa-check-circle fa-lg hec_saving_check_color"></i>
                                    </div>
                                    <div v-else>
                                        <i class="fa fa-check-circle fa-lg aube_user_wallet_check_color"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="container center-items text-center m-0 p-0 mt-5">
                <router-link :to="{ name: 'forthing-history' }" class="btn btn-primary forthing-history-button-label">
                    {{ $t('forthing.detail.history-button-label') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { FORTHING_MEMBER_PARENT } from '../../utils/AuthUtil';
    import tokenService from './../../services/TokenService';
    import UserService from './../../services/UserService';

    export default {
        name: 'TokenBalances',

        components: {
        },

        data() {
            return {
                detail: undefined,
                transactions: undefined,
                isChild: true,
                next_wallet_reflection_date: false,
                next_payout_date: undefined,
                two_years_plan_address: undefined,
                two_years_plan_rokes_address: undefined,
            }
        },

        async mounted() {
            await this.fetchUserFrontendData();
            await this.fetchUserFrontendDataDetail();

            if (this.isChild) {
                this.$router.push('/settings');
                return;
            }
            this.fetch();
        },

        created() {
        },

        methods: {
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isChild = data.is_child;
                this.member_type_id = data.member_type_id;
            },
            async fetchUserFrontendDataDetail() {
                const dataDetail = (await UserService.getUserFrontendDataDetail()).data; 
                if(dataDetail.forthing_rate !== null){
                    this.next_payout_date = dataDetail.next_payout_date
                }               
            },
            isPayoutDate() {
                if (this.next_payout_date == undefined || this.next_payout_date == null) { return false; }

                return true;
       
            },
            async fetch() {

                //2年アドレスを取得
                const data = (await UserService.getHecSavingApplyInfo()).data;
                this.two_years_plan_address = data.two_years_plan_address
                this.two_years_plan_rokes_address = data.two_years_plan_rokes_address

                let [ detail, transactions ] = await Promise.all([
                    tokenService.getForthingDetail(),
                    tokenService.getForthingLatestTransactions(),
                ]);

                this.detail = detail.data;
                if(this.member_type_id == FORTHING_MEMBER_PARENT){
                    this.next_wallet_reflection_date = true
                }    
                
                this.transactions = [];

                let txs = transactions.data;
                for (let i in txs) {
                    if (txs.hasOwnProperty(i) && i !== 'meta') {
                        this.transactions.push(txs[i]);
                    }
                }

            }
        }
    }
</script>

<style scoped>
    .balanceBlock {
        display: flex;
        justify-content: space-between;
    }
    .forthing-table {
        border-collapse: separate;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        overflow: hidden;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
    .forthing-history-button-label {
        white-space: nowrap;
    }
    .aube_user_wallet_check_color {
       color: #450080;
    }
    .hec_saving_check_color {
       color: #00ad69;
    }
</style>
